<!-- 标题 -->
<template>
    <div v-if="componentsData.type == 4">
        <div class="bg-divs" v-if="componentsData.content.style_value == 1"
            :style="componentsData.content.version ?
                {
                    ...(componentsData.content.bg_color && { backgroundColor: componentsData.content.bg_color }),
                    ...(componentsData.content.bg_img.picview && componentsData.content.bg_value && { backgroundImage: `url(${componentsData.content.bg_img.picview})` }),
                    padding: `${componentsData.content.paddingData.top}px ${componentsData.content.paddingData.left}px`,
                    margin: `${componentsData.content.marginData.top}px ${componentsData.content.marginData.left}px`,
                    borderRadius: `${componentsData.content.radiusData.top}px ${componentsData.content.radiusData.top}px ${componentsData.content.radiusData.bottom}px ${componentsData.content.radiusData.bottom}px`
                } : {}
            "
        >
            <div class="dec-left" :style="{ background: decLeft }"></div>
            <div class="dec-content" :style="`color: ${componentsData.content.text_color};font-size: ${componentsData.content.size}px;`">{{ componentsData.content.text }}</div>
            <div class="dec-right" :style="{ background: decRight }"></div>
        </div>
        <div v-else class="bg-div"
            :style="componentsData.content.version ?
                {
                    ...(componentsData.content.bg_color && { backgroundColor: componentsData.content.bg_color }),
                    ...(componentsData.content.bg_img.picview && componentsData.content.bg_value && { backgroundImage: `url(${componentsData.content.bg_img.picview})` }),
                    padding: `${componentsData.content.paddingData.top}px ${componentsData.content.paddingData.left}px`,
                    margin: `${componentsData.content.marginData.top}px ${componentsData.content.marginData.left}px`,
                    borderRadius: `${componentsData.content.radiusData.top}px ${componentsData.content.radiusData.top}px ${componentsData.content.radiusData.bottom}px ${componentsData.content.radiusData.bottom}px`
                } : {}
            "
        >
            <div :style="`font-size: ${componentsData.content.size}px;color: ${componentsData.content.text_color};text-align: ${componentsData.content.position};`" >
                {{ componentsData.content.text }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        componentsData: {
            type: Object,
            default: {},
        },
    },
    data() {
        return {};
    },
    computed: {
        decLeft() {
            return `linear-gradient(to left, ${this.componentsData.content.dec_color}, transparent)`
        },
        decRight() {
            return `linear-gradient(to right, ${this.componentsData.content.dec_color}, transparent)`
        },
    },
    mounted() {},
    methods: {},
};
</script>

<style scoped>
.dec-left {
    margin: 0 12px;
    width: 50px;
    height: 4px;
    border-radius: 2px;
}
.dec-right {
    margin: 0 12px;
    width: 50px;
    height: 4px;
    border-radius: 2px;
}
.dec-content {
    max-width: 200px;
    white-space: nowrap; /* 确保文本不会换行 */
    overflow: hidden; /* 隐藏溢出的文本 */
    text-overflow: ellipsis; /* 显示省略号来代表被修剪的文本 */
}
.bg-divs {
    display: flex;
    align-items: center;
    justify-content: center;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
}
.bg-div {
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
}
</style>